<template>
  <v-dialog
    id="requestDialog"
    :value="enableDialog"
    persistent
    width="1600"
    @keydown.esc="cancelButtonClickEvent"
    @close="cancelButtonClickEvent"
  >
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>積替運搬</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text style="max-height: 75vh;overflow-y: auto;" class="mt-2">
        <validation-observer ref="pickingFormValidate">
          <!-- 積替運搬日 -->
          <v-row >
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="forms.pickingRequestDate"
                @dateChangedCallback="pickingRequestDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{required: true}"
                    name="積替運搬日"
                    class="requiredMark"
                  >
                    <v-text-field
                      v-model="forms.pickingRequestDate"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="積替運搬日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- 積替運搬日 -->

          <v-row>
            <v-chip v-if="this.forms.trader_location_name">
              事業場（引き取り場所）: {{ this.forms.trader_location_name }}
            </v-chip>
            <v-chip v-if="this.forms.transport_name">
              引取業者: {{ this.forms.transport_name }}
            </v-chip>
            <v-chip v-if="this.forms.trader_name">
              運搬先事業者: {{ this.forms.trader_name }}
            </v-chip>
            <v-chip v-if="this.forms.to_trader_location_name">
              運搬先事業場: {{ this.forms.to_trader_location_name }}
            </v-chip>
          </v-row>
          <!-- 検索項目 -->
          <v-row>
            <v-col>
              <v-expansion-panels
                v-model="panel"
              >
                <!-- ■■■条件を指定して検索（積替運搬） -->
                <v-expansion-panel>
                  <v-expansion-panel-header class="panel-header-color panel-selectable">
                    <strong>
                      <v-icon class="panel-header-color">
                        mdi-magnify
                      </v-icon>
                      &nbsp;条件を指定して検索（積替運搬）
                    </strong>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <validation-observer ref="pickingConditionValidate">
                      <v-form>

                        <v-card flat light>
                          <v-card-text class="mx-0">

                            <!-- 事業場（引き取り場所）, 引取業者 -->
                            <v-row dense v-if="!conditions">
                              <v-col cols="12" md="6">
                                <infinite-tenant-location-auto-complete
                                  :location-id="searchForm.pLocationId"
                                  :location-code="searchForm.pLocationCode"
                                  classes="search-font"
                                  label="事業場（引き取り場所）"
                                  required
                                  rounded
                                  :without-invisible="true"
                                  @update:values="pLocationChangedCallback"
                                >
                                  <template v-slot:item="slotProps">
                                    <v-chip
                                      :title="slotProps.item?.code"
                                      color="#e0ffff"
                                      label
                                      small
                                    >
                                      {{ slotProps.item?.code }}
                                    </v-chip>
                                    &nbsp;{{ slotProps.item.text }}
                                    <small class="text--disabled">{{ slotProps.item.address }}</small>
                                  </template>
                                </infinite-tenant-location-auto-complete>
                              </v-col>
                              <v-col cols="12" md="6">
                                <infinite-trader-auto-complete
                                  :trader-id="searchForm.pTransporterId"
                                  classes="search-font"
                                  required
                                  rounded
                                  label="引取業者"
                                  :without-invisible="true"
                                  with-none-location
                                  @update:values="pTransporterChangedCallback"
                                >
                                  <template v-slot:append-outer>
                                    <choose-trader-button
                                      :small-button="true"
                                      :search-type="`transport`"
                                      :button-caption="`引取業者を選択`"
                                      :without-invisible="true"
                                      with-none-location
                                      @choseTraderCallback="choseTransporterCallback"
                                    />
                                  </template>
                                </infinite-trader-auto-complete>
                              </v-col>
                            </v-row>
                            <!-- /事業場（引き取り場所）, 引取業者 -->

                            <!-- 運搬先事業者, 運搬先事業場 -->
                            <infinite-trader-and-location-auto-complete
                              v-if="!conditions"
                              :trader-id="searchForm.pTraderId"
                              :location-id="searchForm.pTraderLocationId"
                              :location-code="searchForm.pTraderLocationCode"
                              classes="search-font"
                              trader-label="運搬先事業者"
                              location-label="運搬先事業場"
                              trader-required
                              location-required
                              search-type="either"
                              trader-md="6"
                              location-md="6"
                              rounded
                              :without-invisible="true"
                              @update:values="pTraderChangedCallback"
                            >
                              <template v-slot:trader-append-outer>
                                <choose-trader-button
                                  :small-button="true"
                                  :button-caption="`運搬先事業者を選択`"
                                  :without-invisible="true"
                                  @choseTraderCallback="choseTraderCallback"
                                />
                              </template>
                              <template v-slot:location-item="slotProps">
                                <v-chip
                                  :title="slotProps.item?.code"
                                  color="#e0ffff"
                                  label
                                  small
                                >
                                  {{ slotProps.item?.code }}
                                </v-chip>
                                &nbsp;{{ slotProps.item.text }}
                                <small class="text--disabled">{{ slotProps.item.address }}</small>
                              </template>
                            </infinite-trader-and-location-auto-complete>
                            <!-- /運搬先事業者, 運搬先事業場 -->

                            <!-- 処分場, 処分事業場 -->
                            <infinite-trader-and-location-auto-complete
                              :trader-id="searchForm.disposalId"
                              :location-id="searchForm.disposalLocationId"
                              :location-code="searchForm.disposalLocationCode"
                              classes="search-font"
                              trader-md="6"
                              location-md="5"
                              search-type="trader"
                              trader-label="処分場"
                              location-label="処分事業場"
                              rounded
                              :without-invisible="true"
                              @update:values="disposalChangedCallback"
                            >
                              <template v-slot:trader-append-outer>
                                <choose-trader-button
                                  :small-button="true"
                                  :exclude-me="true"
                                  :without-invisible="true"
                                  :search-type="`trader`"
                                  :button-caption="`処分場を選択`"
                                  @choseTraderCallback="choseDisposalCallback"
                                />
                              </template>
                              <template v-slot:location-item="slotProps">
                                <v-chip
                                  :title="slotProps.item?.code"
                                  color="#e0ffff"
                                  label
                                  small
                                >
                                  {{ slotProps.item?.code }}
                                </v-chip>
                                &nbsp;{{ slotProps.item.text }}
                                <small class="text--disabled">{{ slotProps.item.address }}</small>
                              </template>
                            </infinite-trader-and-location-auto-complete>
                            <!-- 処分場, 処分事業場 -->

                            <!-- 回収日(From), 回収日（To）, 品目, 引取搬入番号発番済も表示, 引取搬入番号 -->
                            <v-row>
                              <v-col cols="12" md="2">
                                <cs-date-picker
                                  :date.sync="searchForm.pStartDate"
                                  @dateChangedCallback="pStartDateChangedCallback"
                                >
                                  <template v-slot="{ on, attrs }">
                                    <v-text-field
                                      v-model="searchForm.pStartDate"
                                      v-bind="attrs"
                                      v-on="on"
                                      append-icon="mdi-calendar"
                                      clearable
                                      dense
                                      hide-details="auto"
                                      label="回収日（From）"
                                      outlined
                                      persistent-hint
                                      persistent-placeholder
                                      placeholder="日付を選択"
                                      readonly
                                      rounded
                                      style="font-size: 80%"
                                      @click:clear="pStartDateClearEvent"
                                    >
                                      <template v-slot:append-outer>
                                        <div
                                          v-if="$vuetify.breakpoint.mdAndUp"
                                          style="vertical-align: middle"
                                        >
                                          〜
                                        </div>
                                      </template>
                                    </v-text-field>
                                  </template>
                                </cs-date-picker>
                              </v-col>
                              <v-col cols="12" md="2">
                                <cs-date-picker
                                  :date.sync="searchForm.pEndDate"
                                  @dateChangedCallback="pEndDateChangedCallback"
                                >
                                  <template v-slot="{ on, attrs }">
                                    <v-text-field
                                      v-model="searchForm.pEndDate"
                                      v-bind="attrs"
                                      v-on="on"
                                      append-icon="mdi-calendar"
                                      clearable
                                      dense
                                      hide-details="auto"
                                      label="回収日（To）"
                                      outlined
                                      persistent-hint
                                      persistent-placeholder
                                      placeholder="日付を選択"
                                      readonly
                                      rounded
                                      style="font-size: 80%"
                                      @click:clear="pEndDateClearEvent"
                                    />
                                  </template>
                                </cs-date-picker>
                              </v-col>
                              <v-col cols="12" md="3">
                                <item-autocomplete
                                  v-model="searchForm.pItemId"
                                  :items="items"
                                  label="品目"
                                  classes="search-font"
                                  clearable
                                  dense
                                  hide-details="auto"
                                  outlined
                                  rounded
                                  multiple
                                  chips
                                  small-chips
                                  deletable-chips
                                  persistent-placeholder
                                  @change="searchPickingButtonClickEvent()"
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <v-checkbox
                                  v-model="searchForm.pWithPublished"
                                  dense
                                  class="mt-2"
                                  label="引取搬入番号発番済も表示"
                                  style="font-size: 80%;"
                                  hide-details="auto"
                                  persistent-hint
                                  @change="searchPickingButtonClickEvent"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pRequestNo"
                                  class="search-font"
                                  dense
                                  label="引取搬入番号"
                                  outlined
                                  rounded
                                  hide-details="auto"
                                  persistent-placeholder
                                  @blur="searchPickingButtonClickEvent"
                                  @click:clear="searchForm.pEndDate = null; searchPickingButtonClickEvent()"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <!-- 回収日(From), 回収日（To）, 品目, 引取搬入番号発番済も表示, 引取搬入番号 -->

                            <!-- マニフェスト区分, DXEマニ番号, 並び替え -->
                            <v-row dense>
                              <v-col cols="12" md="2">
                                <v-select
                                  v-model="searchForm.pManifestType"
                                  :items="manifestTypes"
                                  class="search-font"
                                  clearable
                                  dense
                                  outlined
                                  rounded
                                  label="マニフェスト区分"
                                  hide-details="auto"
                                  persistent-placeholder
                                  @change="searchPickingButtonClickEvent"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pManifestId"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  label="DXEマニ番号"
                                  clearable
                                  outlined
                                  persistent-hint
                                  persistent-placeholder
                                  rounded
                                  placeholder="カンマ区切りで入力"
                                  hint="例: 1, 2, 3"
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pManifestId = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-select
                                  v-model="searchForm.pSortType"
                                  :items="sortMembers"
                                  class="search-font"
                                  clearable
                                  dense
                                  outlined
                                  rounded
                                  label="並び替え"
                                  hide-details="auto"
                                  persistent-placeholder
                                  @change="searchPickingButtonClickEvent"
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                            <!-- /マニフェスト区分, DXEマニ番号, 並び替え -->

                            <!-- カスタムラベル -->
                            <v-row v-if="isJwMode" dense>
                              <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                                <v-text-field
                                  v-model="searchForm.pCustomLabels1"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  :label="customLabel.custom_labels1_name"
                                  :disabled="(searchForm.pCustomLabels1Unregistered)"
                                  clearable
                                  outlined
                                  persistent-placeholder
                                  rounded
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pCustomLabels1 = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pCustomLabels2"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  :label="customLabel.custom_labels2_name"
                                  :disabled="(searchForm.pCustomLabels2Unregistered)"
                                  clearable
                                  outlined
                                  persistent-placeholder
                                  rounded
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pCustomLabels2 = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pCustomLabels3"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  :label="customLabel.custom_labels3_name"
                                  :disabled="(searchForm.pCustomLabels3Unregistered)"
                                  clearable
                                  outlined
                                  persistent-placeholder
                                  rounded
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pCustomLabels3 = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pCustomLabels4"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  :label="customLabel.custom_labels4_name"
                                  :disabled="(searchForm.pCustomLabels4Unregistered)"
                                  clearable
                                  outlined
                                  persistent-placeholder
                                  rounded
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pCustomLabels4 = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pCustomLabels5"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  :label="customLabel.custom_labels5_name"
                                  :disabled="(searchForm.pCustomLabels5Unregistered)"
                                  clearable
                                  outlined
                                  persistent-placeholder
                                  rounded
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pCustomLabels5 = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                                <v-text-field
                                  v-model="searchForm.pCustomLabels6"
                                  class="search-font"
                                  dense
                                  hide-details="auto"
                                  :label="customLabel.custom_labels6_name"
                                  :disabled="(searchForm.pCustomLabels6Unregistered)"
                                  clearable
                                  outlined
                                  persistent-placeholder
                                  rounded
                                  @blur="searchPickingButtonClickEvent()"
                                  @click:clear="searchForm.pCustomLabels6 = null; searchPickingButtonClickEvent()"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense v-if="isJwMode">
                              <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                                <v-checkbox
                                  v-model="searchForm.pCustomLabels1Unregistered"
                                  label=""
                                  dense
                                  hide-details="auto"
                                  @change="searchPickingButtonClickEvent()"
                                >
                                  <template v-slot:label>
                                    <small>未入力データのみ検索</small>
                                  </template>
                                </v-checkbox>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                                <v-checkbox
                                  v-model="searchForm.pCustomLabels2Unregistered"
                                  label=""
                                  dense
                                  hide-details="auto"
                                  @change="searchPickingButtonClickEvent()"
                                >
                                  <template v-slot:label>
                                    <small>未入力データのみ検索</small>
                                  </template>
                                </v-checkbox>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                                <v-checkbox
                                  v-model="searchForm.pCustomLabels3Unregistered"
                                  label=""
                                  dense
                                  hide-details="auto"
                                  @change="searchPickingButtonClickEvent()"
                                >
                                  <template v-slot:label>
                                    <small>未入力データのみ検索</small>
                                  </template>
                                </v-checkbox>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                                <v-checkbox
                                  v-model="searchForm.pCustomLabels4Unregistered"
                                  label=""
                                  dense
                                  hide-details="auto"
                                  @change="searchPickingButtonClickEvent()"
                                >
                                  <template v-slot:label>
                                    <small>未入力データのみ検索</small>
                                  </template>
                                </v-checkbox>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                                <v-checkbox
                                  v-model="searchForm.pCustomLabels5Unregistered"
                                  label=""
                                  dense
                                  hide-details="auto"
                                  @change="searchPickingButtonClickEvent()"
                                >
                                  <template v-slot:label>
                                    <small>未入力データのみ検索</small>
                                  </template>
                                </v-checkbox>
                              </v-col>

                              <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                                <v-checkbox
                                  v-model="searchForm.pCustomLabels6Unregistered"
                                  label=""
                                  dense
                                  hide-details="auto"
                                  @change="searchPickingButtonClickEvent()"
                                >
                                  <template v-slot:label>
                                    <small>未入力データのみ検索</small>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>
                            <!-- /カスタムラベル -->

                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              color="primary"
                              @click="searchPickingButtonClickEvent"
                            >
                              <v-icon>
                                mdi-magnify
                              </v-icon>
                              &nbsp;検索
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-form>
                    </validation-observer>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- /条件を指定して検索（積替運搬） -->

              </v-expansion-panels>
            </v-col>
          </v-row>
          <!-- /検索項目 -->

          <!-- 紐付けされているマニフェスト一覧-->
          <v-row v-if="conditions">
            <v-col>
              <!-- 一覧 -->
              <v-card flat class="rounded-card">
                <v-card-subtitle>
                  <v-row>
                    <v-col cols="12" md="4">
                      紐付けされているマニフェスト
                    </v-col>
                    <v-col cols="12" md="8">
                      <custom-pagination
                        :page-number="mapPage"
                        :per-page="mapPerPage"
                        :pagination="mapPagination"
                        :total-visible="totalVisible"
                        @pageChanged="pageMapChangeEvent"
                        @perPageChanged="perPageMapChangeEvent"
                      />
                    </v-col>
                  </v-row>

                </v-card-subtitle>
                <v-card-text>
                  <v-data-table
                    v-model="currentSelectedRequests"
                    :headers="tableHeaders"
                    :items="mapRequests"
                    :items-per-page="-1"
                    dense
                    disable-sort
                    hide-default-footer
                    show-select
                    @toggle-select-all="selectMapAllToggle"
                    @click:row="toggleMapRowSelection"
                  >
                    <!-- 選択チェックボックス -->
                    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                      <v-simple-checkbox
                        :value="isSelected"
                        @input="select($event)"
                        @click="checkboxMapClickEvent(!isSelected, item)"
                      />
                    </template>
                    <!-- /選択チェックボックス -->

                    <!-- マニフェスト番号 -->
                    <template v-slot:[`item.manifest_no`]="{item}">
                      <small>{{ item.manifest_no }}</small>
                    </template>
                    <!-- /マニフェスト番号 -->

                    <!-- DXEマニ番号 -->
                    <template v-slot:[`item.id`]="{item}">
                      <small>{{ item.id }}</small>
                    </template>
                    <!-- /DXEマニ番号 -->

                    <!-- 引取搬入番号 -->
                    <template v-slot:[`item.request_no`]="{item}">
                      <small>{{ item.request_no }}</small>
                    </template>
                    <!-- /引取搬入番号 -->

                    <!-- 回収日 -->
                    <template v-slot:[`item.collected_date`]="{item}">
                      <small>{{ item.collected_date | date_format }}</small>
                    </template>
                    <!-- /回収日 -->

                    <!-- 排出事業者／事業場 -->
                    <template v-slot:[`item.emission`]="{item}">
                      <div v-if="item.emission" :title="item.emission.name">
                        <small
                          class="text-ellipsis text-sm-caption"
                          style="max-width: 180px;display: inline-block;vertical-align: middle;"
                        >
                          {{ item.emission.name }}
                        </small>
                        <v-tooltip
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              v-if="item.emission.addresses"
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <small
                            v-if="item.emission.addresses"
                          >
                            {{ item.emission.addresses }}
                          </small>
                        </v-tooltip>
                      </div>
                      <div v-if="item.emission_location" :title="item.emission_location.name">
                        <small
                          class="text-ellipsis text-sm-caption"
                          style="max-width: 180px;display: inline-block;vertical-align: middle;"
                        >{{ item.emission_location.name}}</small>
                        <v-tooltip
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              v-if="item.emission_location.addresses"
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <small
                            v-if="item.emission_location.addresses"
                          >
                            {{ item.emission_location.addresses }}
                          </small>
                        </v-tooltip>
                      </div>
                    </template>
                    <!-- /排出事業者／事業場 -->

                    <!-- 運搬先 -->
                    <template v-slot:[`item.trader`]="{ item }">
                      <div v-if="item.trader" :title="item.trader.name">
                        <small
                          class="text-ellipsis text-sm-caption"
                          style="max-width: 150px;display: inline-block;vertical-align: middle;"
                        >
                          {{ item.trader.name }}
                        </small>
                        <v-tooltip
                          v-if="item.trader.location"
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <div>
                            <strong>{{ item.trader.location.name }}</strong>
                            <br />
                            <small>
                              {{ item.trader.location.address }}
                            </small>
                          </div>
                        </v-tooltip>
                      </div>
                    </template>
                    <!-- /運搬先 -->

                    <!-- 処分事業場 -->
                    <template v-slot:[`item.disposer_location_name`]="{item}">
                      <small>{{ item.disposer_location_name }}</small>
                    </template>
                    <!-- /処分事業場 -->

                    <template v-slot:[`item.item_name`]="{item}">
                      <small>{{ item.item_name }}</small>
                    </template>

                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col>
                      <custom-pagination
                        :page-number="mapPage"
                        :per-page="mapPerPage"
                        :pagination="mapPagination"
                        :total-visible="totalVisible"
                        @pageChanged="pageMapChangeEvent"
                        @perPageChanged="perPageMapChangeEvent"
                      />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
              <!-- /一覧 -->
            </v-col>
          </v-row>
          <!-- /紐付けされているマニフェスト一覧-->

          <v-row>
            <v-col>
              <v-divider />
            </v-col>
          </v-row>

          <!-- 一覧 -->
          <v-row>
            <v-col>
              <v-card flat class="rounded-card">
                <v-card-subtitle>
                  <v-row>
                    <v-col cols="12" md="3">検索結果</v-col>
                    <v-col cols="12" md="9">
                      <custom-pagination
                        :page-number="page"
                        :per-page="perPage"
                        :pagination="pagination"
                        :total-visible="totalVisible"
                        @pageChanged="pageChangeEvent"
                        @perPageChanged="perPageChangeEvent"
                      />
                    </v-col>
                  </v-row>
                </v-card-subtitle>
                <v-card-text>
                  <v-data-table
                    v-model="currentSelectedItems"
                    :headers="tableHeaders"
                    :items="requests"
                    :items-per-page="-1"
                    dense
                    disable-sort
                    hide-default-footer
                    show-select
                    @toggle-select-all="selectAllToggle($event)"
                    @click:row="toggleRowSelection"
                  >
                    <!-- 選択チェックボックス -->
                    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                      <v-simple-checkbox
                        :value="isSelected"
                        :readonly="item.disabled"
                        :disabled="item.disabled"
                        @input="select($event)"
                        @click="checkboxClickEvent(!isSelected, item)"
                      />
                    </template>
                    <!-- /選択チェックボックス -->

                    <!-- マニフェスト番号 -->
                    <template v-slot:[`item.manifest_no`]="{item}">
                      <small>{{ item.manifest_no }}</small>
                    </template>
                    <!-- /マニフェスト番号 -->

                    <!-- DXEマニ番号 -->
                    <template v-slot:[`item.id`]="{item}">
                      <small>{{ item.id }}</small>
                    </template>
                    <!-- /DXEマニ番号 -->

                    <!-- 引取搬入番号 -->
                    <template v-slot:[`item.request_no`]="{item}">
                      <small>{{ item.request_no }}</small>
                    </template>
                    <!-- /引取搬入番号 -->

                    <!-- 回収日 -->
                    <template v-slot:[`item.collected_date`]="{item}">
                      <small>{{ item.collected_date | date_format }}</small>
                    </template>
                    <!-- /回収日 -->

                    <!-- 排出事業者／事業場 -->
                    <template v-slot:[`item.emission`]="{item}">
                      <div v-if="item.emission" :title="item.emission.name">
                        <small
                          class="text-ellipsis text-sm-caption"
                          style="max-width: 180px;display: inline-block;vertical-align: middle;"
                        >
                          {{ item.emission.name }}
                        </small>
                        <v-tooltip
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              v-if="item.emission.addresses"
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <small
                            v-if="item.emission.addresses"
                          >
                            {{ item.emission.addresses }}
                          </small>
                        </v-tooltip>
                      </div>
                      <div v-if="item.emission_location" :title="item.emission_location.name">
                        <small
                          class="text-ellipsis text-sm-caption"
                          style="max-width: 180px;display: inline-block;vertical-align: middle;"
                        >{{ item.emission_location.name}}</small>
                        <v-tooltip
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              v-if="item.emission_location.addresses"
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <small
                            v-if="item.emission_location.addresses"
                          >
                            {{ item.emission_location.addresses }}
                          </small>
                        </v-tooltip>
                      </div>
                    </template>
                    <!-- /排出事業者／事業場 -->

                    <!-- 運搬先 -->
                    <template v-slot:[`item.trader`]="{ item }">
                      <div v-if="item.trader" :title="item.trader.name">
                        <small
                          class="text-ellipsis text-sm-caption"
                          style="max-width: 150px;display: inline-block;vertical-align: middle;"
                        >
                          {{ item.trader.name }}
                        </small>
                        <v-tooltip
                          v-if="item.trader.location"
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <div>
                            <strong>{{ item.trader.location.name }}</strong>
                            <br />
                            <small>
                              {{ item.trader.location.address }}
                            </small>
                          </div>
                        </v-tooltip>
                      </div>
                    </template>
                    <!-- /運搬先 -->

                    <!-- 処分事業場 -->
                    <template v-slot:[`item.disposer_location_name`]="{item}">
                      <small>{{ item.disposer_location_name }}</small>
                    </template>
                    <!-- /処分事業場 -->

                    <template v-slot:[`item.item_name`]="{item}">
                      <small>{{ item.item_name }}</small>
                    </template>

                  </v-data-table>
                </v-card-text>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <custom-pagination
                        :page-number="page"
                        :per-page="perPage"
                        :pagination="pagination"
                        :total-visible="totalVisible"
                        @pageChanged="pageChangeEvent"
                        @perPageChanged="perPageChangeEvent"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- /一覧 -->

        </validation-observer>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <VButtonProcessing
          :disabled="(selectedItems.length <= 0 && !conditions) || !conditionMatch"
          :onclick="registerButtonClickEvent"
          color="primary"
          elevation="5"
        >
          登録
        </VButtonProcessing>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ChooseTraderButton from "@/driver/components/ChooseTraderButton"
import VButtonProcessing from '@/components/VButtonProcessing.vue'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import InfiniteTenantLocationAutoComplete from "@/driver/components/InfiniteTenantLocationAutoComplete.vue";
import InfiniteTraderAutoComplete from "@/driver/components/InfiniteTraderAutoComplete.vue";
import InfiniteTraderAndLocationAutoComplete from "@/driver/components/InfiniteTraderAndLocationAutoComplete.vue";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: 'PickingRequestDialog',
  components: {
    InfiniteTraderAutoComplete,
    InfiniteTenantLocationAutoComplete,
    InfiniteTraderAndLocationAutoComplete,
    CustomPagination,
    ChooseTraderButton,
    VButtonProcessing,
    ItemAutocomplete
  },
  mixins: [],
  props: {
    /**
     * ダイアログの表示制御
     * @type { boolean }
     * @default false
     */
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 検索条件
     * @type { Object }
     */
    conditions: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      panel: 0,
      page: 1,
      perPage: 50,
      mapPage: 1,
      mapPerPage: 50,
      total_count: null,
      totalVisible: 7,
      forms: {
        order_id: null,
        pickingRequestDate: null,
        trader_location_code: null,
        trader_location_name: null,
        transport_id: null,
        transport_name: null,
        trader_id: null,
        trader_name: null,
        to_trader_location_code: null,
        to_trader_location_name: null,
      },
      searchForm: {
        searchType: null,
        pLocationId: null,
        pLocationCode: null,
        pTransporterId: null,
        pTransporterName: null,
        pTraderId: null,
        pTraderName: null,
        pTraderLocationId: null,
        pTraderLocationCode: null,
        disposalId: null,
        disposalName: null,
        disposalLocationId: null,
        disposalLocationCode: null,
        pManifestType: null,
        pSortType: null,
        pStartDate: null,
        pEndDate: null,
        pItemId: null,
        pWithPublished: false,
        pManifestId: null,
        pRequestNo: null,
        pCustomLabels1: null,
        pCustomLabels2: null,
        pCustomLabels3: null,
        pCustomLabels4: null,
        pCustomLabels5: null,
        pCustomLabels6: null,
        pCustomLabels1Unregistered: false,
        pCustomLabels2Unregistered: false,
        pCustomLabels3Unregistered: false,
        pCustomLabels4Unregistered: false,
        pCustomLabels5Unregistered: false,
        pCustomLabels6Unregistered: false,
      },
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' },
        { value: 'transfer_form', text: '電子マニフェスト(取込)' },
      ],
      sortMembers: [
        { value: 'updated', text: '更新日降順' },
        { value: 'collected', text: '回収日昇順' },
      ],
      tableHeaders: [
        { value: 'manifest_no', text: 'マニフェスト番号', width: '9%' },
        { value: 'id', text: 'DXEマニ番号', width: '8%' },
        { value: 'request_no', text: '引取搬入番号', width: '8%' },
        { value: 'collected_date', text: '回収日', width: '7%' },
        { value: 'emission', text: '排出事業者\r\n排出事業場', width: '18%' },
        { value: 'trader', text: '運搬先', width: '15%' },
        { value: 'disposer_location_name', text: '処分事業場', width: '13%' },
        { value: 'item_name', text: '品目', width: '22%' },
      ],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      mapPagination: {
        current_page: 1,
        total_count: 0
      },
      items: [],
      /* 検索結果マニフェスト */
      requests: [],
      /* 紐付けされたマニフェスト */
      mapRequests: [],
      /* 送信用選択情報 */
      selectedItems: [],
      /* 送信用紐付けされたマニフェスト選択情報 */
      selectedMapItems: [],
      /* ページ毎に管理する選択情報 */
      currentSelectedItems: [],
      currentSelectedRequests: [],
      /* ページ毎に管理する選択不可件数 */
      currentDisabledCount: 0,
      /* カスタムラベルマスタ */
      customLabel: null,
      selectedPTraderIds: [],
      selectedDisposalIds: [],

    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isJwMode: 'use_jw_mode',
    }),
    conditionMatch () {
      return (
        this.forms.trader_location_code === this.searchForm.pLocationCode &&
        this.forms.transport_id === this.searchForm.pTransporterId &&
        this.forms.trader_id === this.searchForm.pTraderId &&
        this.forms.to_trader_location_code === this.searchForm.pTraderLocationCode
      )
    },
  },
  watch: {
    requests : {
      handler: function () {
        this.currentDisabledCount = 0
        this.requests.map((item) => {
          if (item.disabled) {
            if (item.disabled) this.currentDisabledCount += 1
          }
        })
      },
      deep: true
    },
    enableDialog (newValue) {
      this.list_clear()
      this.$nextTick(() => this.$refs.pickingFormValidate.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      if (newValue) {
        if (this.conditions!=null) {
          this.setVariable()
          this.searchManifestMapRequests ()
        }
      }
    },
    'searchForm.pWithPublished': function(newVal) {
      if (!newVal) {
        this.searchForm.pRequestNo = null
      }
    },
  },
  created() {
    this.fetchItems().then((content) =>{
      this.items = content.items
    })
    this.fetchCustomLabel().then((content) => { this.customLabel = content })
  },
  methods: {
    ...mapActions('DriverManifestRequest', {
      fetchManifestRequest: 'index',
    }),
    ...mapActions('DriverManifestMapRequest', {
      fetchManifestMapRequest: 'index',
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index'
    }),
    ...mapActions('DriverOrderRequest', {
      createPickingRequest: 'create'
    }),
    ...mapActions('snackbar', {
      showError: 'showError',
    }),
    ...mapActions('DriverMasterSearchCustomLabel', {
      fetchCustomLabel: 'index',
    }),
    /**
     * 事業場（引取場所） チェンジコールバック
     * @param location_id
     * @param location_code
     */
    pLocationChangedCallback (location_id, location_code) {
      this.searchForm.pLocationId = location_id;
      this.searchForm.pLocationCode = location_code;
      this.searchPickingButtonClickEvent()
    },
    /**
     * 引取業者ID チェンジコールバック
     * @param id
     */
    pTransporterIdChangeCallback (id) {
      this.searchForm.pTransporterId = id;
      this.$nextTick(() => this.searchPickingButtonClickEvent())
    },
    pTransporterChangedCallback (trader_id) {

      let changed = false;

      console.log("pTransporterChangedCallback", this.searchForm.pTransporterId, trader_id)


      if (this.searchForm.pTransporterId !== trader_id) {
        changed = true;
      }

      this.searchForm.pTransporterId = trader_id;


      if (changed) {
        this.$nextTick(() => this.searchPickingButtonClickEvent());
      }

    },
    /**
     * 引取業者ダイアログ コールバック
     * @param item
     */
    choseTransporterCallback (item) {
      this.searchForm.pTransporterId = item.id
      this.$nextTick(() => this.searchPickingButtonClickEvent())
    },
    /**
     * 運搬先 チェンジコールバック
     * @param trader_id
     * @param location_id
     * @param location_code
     */
    pTraderChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.searchForm.pTraderId !== trader_id) {
        changed = true;
      }

      if (this.searchForm.pTraderLocationId !== location_id) {
        changed = true;
      }
      this.searchForm.pTraderId = trader_id;
      this.searchForm.pTraderLocationId = location_id;
      this.searchForm.pTraderLocationCode = location_code;

      if (changed) {
        this.$nextTick(() => {
          this.searchPickingButtonClickEvent()
        })
      }
    },
    /**
     * 運搬先事業者ダイアログ コールバック
     * @param item
     */
    choseTraderCallback (item) {
      this.searchForm.pTraderId = item.id;
      this.searchForm.pTraderLocationId = null;
      this.searchForm.pTraderLocationCode = null;
      this.$nextTick(() => {
        this.searchPickingButtonClickEvent()
      })
    },
    disposalChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.searchForm.disposalId !== trader_id) {
        changed = true;
      }

      if (this.searchForm.disposalLocationId !== location_id) {
        changed = true;
      }
      this.searchForm.disposalId = trader_id;
      this.searchForm.disposalLocationId = location_id
      this.searchForm.disposalLocationCode = location_code
      if (changed) {
        this.$nextTick(() => {
          this.searchPickingButtonClickEvent()
        })
      }
    },
    /**
     * 処分場 選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseDisposalCallback (item) {
      this.searchForm.disposalId = item.id;
      this.searchForm.disposalLocationId = null;
      this.searchForm.disposalLocationCode = null;
      this.$nextTick(() => {
        this.searchPickingButtonClickEvent()
      })
    },
    /**
     * 積替運搬日変更　コールバック
     */
    pickingRequestDateChangedCallback (value) {
      this.forms.pickingRequestDate = value;
    },
    /**
     * 回収日（from）変更　コールバック
     */
    pStartDateChangedCallback (value) {
      this.searchForm.pStartDate = value;
      this.searchPickingButtonClickEvent();

    },
    pStartDateClearEvent() {
      this.searchForm.pStartDate = null;
      this.searchPickingButtonClickEvent();
    },
    /**
     * 回収日（to）変更　コールバック
     */
    pEndDateChangedCallback (value) {
      this.searchForm.pEndDate = value;
      this.searchPickingButtonClickEvent();
    },
    pEndDateClearEvent () {
      this.searchForm.pEndDate = null;
      this.searchPickingButtonClickEvent();
    },
    /**
     * 検索ボタンクリック
     */
    searchPickingButtonClickEvent () {
      this.list_clear();
      this.$refs.pickingConditionValidate.validate().then((result) => {
        if (result) {
          this.page = 1
          this.searchManifestRequests()
          this.selectedItems = []
          this.currentSelectedItems = []
        }
      })
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$refs.pickingFormValidate.validateWithInfo().then(({ isValid, errors }) => {
            if(isValid) {
              let removeItemIds = []
              let requestItems = []
              for (const item of this.selectedMapItems) {
                if (!item.selected) {
                  removeItemIds.push(item.id)
                }
              }
              this.selectedItems.map(item => {
                requestItems.push(item)
              })
              let params = {
                //検索種別
                search_type: 'picking',
                //オーダーID（編集時のみ）
                order_id: this.forms.order_id,
                // 積替運搬日
                plan_date: this.forms.pickingRequestDate,
                order_pickup_attributes: {
                  //オーダー引取ID（編集時のみ）
                  id: this.forms.order_pickup_id,
                  // 積替運搬日
                  request_date: this.forms.pickingRequestDate,
                  // 事業場（引取場所）コード
                  trader_location_code: this.forms.trader_location_code,
                  // 引取業者
                  transport_id: this.forms.transport_id,
                  // 運搬先事業者ID
                  trader_id: this.forms.trader_id,
                  // 運搬先事業場コード
                  to_trader_location_code: this.forms.to_trader_location_code,
                },
                // 一覧で選択されたマニフェストID
                order_manifests_attributes: requestItems,
                remove_manifest_ids: removeItemIds,
              }
              this.createPickingRequest({params}).then(() => {
                this.$emit('registerCallback')
              })
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
            }
          })
          resolve()
        }, 1000)
      })
    },
    /**
     * 紐づくマニフェストページ チェンジイベント
     */
    pageMapChangeEvent (page) {
      this.mapPage = page
      this.searchManifestMapRequests()
    },
    perPageMapChangeEvent (perPage) {
      this.mapPerPage = perPage;
      this.mapPage = 1;
      this.searchManifestMapRequests()
    },
    /**
     * ページ チェンジイベント
     */
    pageChangeEvent (page) {
      this.page = page;
      this.searchManifestRequests()
    },
    perPageChangeEvent (perPage) {
      this.perPage = perPage;
      this.page = 1;
      this.searchManifestRequests()
    },
    /**
     * 検索処理実行
     */
    searchManifestRequests () {
      let params = this.buildParam()
      this.forms.trader_location_code = this.searchForm.pLocationCode
      this.forms.transport_id = this.searchForm.pTransporterId
      this.forms.trader_id = this.searchForm.pTraderId
      this.forms.to_trader_location_code = this.searchForm.pTraderLocationCode

      this.fetchManifestRequest(params).then((content) => {
        this.requests = content.manifests
        this.pagination = content.pagination
        // 一覧のチェック状態を設定
        this.currentSelectedItems = []
        for (const manifest of this.selectedItems) {
          let target = this.requests.find((v) => v.id === manifest.id)
          if (target) {
            target.selected = true
            this.currentSelectedItems.push(target)
          }
        }
      })
    },
    /**
     * 編集時 紐付けされたマニフェストを検索
     */
    searchManifestMapRequests () {
      let params = {
        search_type: 'picking',
        order_id: this.forms.order_id,
        trader_location_code: this.forms.trader_location_code,
        transport_id: this.forms.transport_id,
        trader_id: this.forms.trader_id,
        to_trader_location_code: this.forms.to_trader_location_code,
        limit: this.mapPerPage,
        page: this.mapPage
      }
      this.fetchManifestMapRequest(params).then((content) => {
        this.mapRequests = content.manifests
        this.mapPagination = content.pagination
        this.currentSelectedRequests = []

        // 一覧情報を走査
        for (let manifest of this.mapRequests) {
          let target = this.selectedMapItems.find((v) => v.id === manifest.id)
          if (target) {
            if (target.selected) {
              this.currentSelectedRequests.push(target)
            }
          } else {
            manifest.selected = true
            this.currentSelectedRequests.push(manifest)
            this.selectedMapItems.push(manifest)
          }
        }

      })
    },
    /**
     * 検索パラメータの生成
     */
    buildParam () {
      return {
        search_type: 'picking',
        p_location_code: this.searchForm.pLocationCode,
        p_transporter_id: this.searchForm.pTransporterId,
        p_trader_id: this.searchForm.pTraderId,
        p_trader_location_code: this.searchForm.pTraderLocationCode,
        p_manifest_type: this.searchForm.pManifestType,
        p_sort_type: this.searchForm.pSortType,
        p_start_date: this.searchForm.pStartDate,
        p_end_date: this.searchForm.pEndDate,
        p_item_id: this.searchForm.pItemId,
        p_with_published: this.searchForm.pWithPublished,
        p_request_no: this.searchForm.pRequestNo,
        p_manifest_id: this.searchForm.pManifestId,
        p_disposal_id: this.searchForm.disposalId,
        p_disposal_location_code: this.searchForm.disposalLocationCode,
        p_custom_labels_1: this.searchForm.pCustomLabels1,
        p_custom_labels_2: this.searchForm.pCustomLabels2,
        p_custom_labels_3: this.searchForm.pCustomLabels3,
        p_custom_labels_4: this.searchForm.pCustomLabels4,
        p_custom_labels_5: this.searchForm.pCustomLabels5,
        p_custom_labels_6: this.searchForm.pCustomLabels6,
        p_custom_labels_1_unregistered: this.searchForm.pCustomLabels1Unregistered,
        p_custom_labels_2_unregistered: this.searchForm.pCustomLabels2Unregistered,
        p_custom_labels_3_unregistered: this.searchForm.pCustomLabels3Unregistered,
        p_custom_labels_4_unregistered: this.searchForm.pCustomLabels4Unregistered,
        p_custom_labels_5_unregistered: this.searchForm.pCustomLabels5Unregistered,
        p_custom_labels_6_unregistered: this.searchForm.pCustomLabels6Unregistered,
        limit: this.perPage,
        page: this.page
      }
    },
    /**
     * 一覧ヘッダーチェックボックス制御
     * disabledとなっている行の背景色の制御
     * @param props
     */
    selectAllToggle (props) {
      if (this.currentSelectedItems.length !== (this.requests.length - this.currentDisabledCount)) {
        props.items.forEach((item) => {
          if (!item.disabled) {
            let currentSelectedItem = this.currentSelectedItems.find(v => v.id === item.id)
            if (!currentSelectedItem) {
              this.currentSelectedItems.push(item)
            }
            let selectedItem = this.selectedItems.find(v => v.id === item.id)
            if (!selectedItem) {
              this.selectedItems.push({id: item.id, manifest_id: item.id, section_no: item.section_no,trader_id: item.trader.id, trader_location_code: item.trader.location.code})
            }
          }
        })
      } else {
        props.items.forEach((item) => {
          this.currentSelectedItems = this.currentSelectedItems.filter(v => v.id !== item.id)
          this.selectedItems = this.selectedItems.filter(v => v.id !== item.id)
        })
      }
    },
    /**
     * 紐付けマニフェスト一覧 行選択トグル
     */
    toggleMapRowSelection(item) {
      const index = this.currentSelectedRequests.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.currentSelectedRequests.splice(index, 1);
        // selectedMapItemsからも削除
        const selectedIndex = this.selectedMapItems.findIndex(v => v.id === item.id);
        if (selectedIndex > -1) {
          this.selectedMapItems.splice(selectedIndex, 1);
        }
      } else {
        // 選択されていない場合は追加
        this.currentSelectedRequests.push(item);
      }
    },
    /**
     * 検索結果一覧 行選択トグル
     */
    toggleRowSelection(item) {
      // disabledな行は選択不可
      if (item.disabled) {
        return;
      }

      const index = this.currentSelectedItems.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.currentSelectedItems.splice(index, 1);
        // selectedItemsからも削除
        const selectedIndex = this.selectedItems.findIndex(v => v.id === item.id);
        if (selectedIndex > -1) {
          this.selectedItems.splice(selectedIndex, 1);
        }
      } else {
        // 選択されていない場合は追加
        this.currentSelectedItems.push(item);
        this.selectedItems.push({id: item.id, manifest_id: item.id, section_no: item.section_no, trader_id: item.trader.id, trader_location_code: item.trader.location.code});
      }
    },
    /**
     * 検索結果 チェックボックス クリックイベント
     * @param value { Boolean } チェックホックスの選択状態
     * @param item { Object } 選択行の詳細情報
     */
    checkboxClickEvent (value, item) {
      if (item.disabled) {
        return false
      }
      if (value) {
        this.currentSelectedItems.push(item)
        this.selectedItems.push({id: item.id, manifest_id: item.id, section_no: item.section_no,trader_id: item.trader.id, trader_location_code: item.trader.location.code})
      } else {
        this.currentSelectedItems = this.currentSelectedItems.filter(v => v.id !== item.id)
        this.selectedItems = this.selectedItems.filter(v => v.id !== item.id)
      }
    },
    /**
     * 紐付けマニフェストチェックボックス クリックイベント 選択したものを保持する
     */
    checkboxMapClickEvent (value, item) {
      // チェックON
      if (value) {
        this.currentSelectedRequests.push(item)
        let selectedMapItem = this.selectedMapItems.find(v => v.id === item.id)
        if (selectedMapItem) {
          selectedMapItem.selected = true
        }
      } else {
        this.currentSelectedRequests = this.currentSelectedRequests.filter(v => v.id !== item.id)
        let selectedMapItem = this.selectedMapItems.find(v => v.id === item.id)
        if (selectedMapItem) {
          selectedMapItem.selected = false
        }
      }
    },

    /**
     * 紐付けマニフェスト一覧ヘッダーチェックボックス制御
     */
    selectMapAllToggle (props) {
      let items = props.items
      let isSelected = props.value
      if (isSelected) {
        for (let item of items) {
          let currentSelectedRequest = this.currentSelectedRequests.find(v => v.id === item.id)
          if (!currentSelectedRequest) {
            this.currentSelectedRequests.push(item)
          }
          let selectedMapItem = this.selectedMapItems.find(v => v.id === item.id)
          if (selectedMapItem) {
            selectedMapItem.selected = true
          }
        }
      } else {
        items.forEach((item) => {
          this.currentSelectedRequests = this.currentSelectedRequests.filter(v => v.id !== item.id)
          let selectedMapItem = this.selectedMapItems.find(v => v.id === item.id)
          if (selectedMapItem) {
            selectedMapItem.selected = false
          }
        })
      }
    },
    /**
     * 初期設定
     */
    setVariable () {
      // オーダーID（編集時のみ）
      this.forms.order_id = this.conditions.order_id
      // オーダー引取ID（編集時のみ）
      this.forms.order_pickup_id = this.conditions.order_pickup_id
      // 積替運搬日
      this.forms.pickingRequestDate = this.conditions.request_date
      // 事業場コード（引取場所）
      this.forms.trader_location_code = this.conditions.trader_location_code
      // 事業場名（引取場所）
      this.forms.trader_location_name = this.conditions.trader_location_name
      // 引取業者
      this.forms.transport_id = this.conditions.transport_id
      // 引取業者名
      this.forms.transport_name = this.conditions.transport_name
      // 運搬先事業者ID
      this.forms.trader_id = this.conditions.trader_id
      // 運搬先事業者名
      this.forms.trader_name = this.conditions.trader_name
      // 運搬先事業場コード
      this.forms.to_trader_location_code = this.conditions.to_trader_location_code
      // 運搬先事業場名
      this.forms.to_trader_location_name = this.conditions.to_trader_location_name

      // 事業場（引取場所）
      this.searchForm.pLocationCode = this.conditions.trader_location_code
      // 引取業者
      this.searchForm.pTransporterId = this.conditions.transport_id
      // 運搬先事業者ID
      this.searchForm.pTraderId = this.conditions.trader_id
      // 運搬先事業場コード
      this.searchForm.pTraderLocationCode = this.conditions.to_trader_location_code
    },
    /**
     * 一覧クリア処理
     */
    list_clear() {
      this.requests = []
      this.mapRequests = []
      this.currentSelectedItems = []
      this.currentSelectedRequests = []
      this.selectedItems = []
      this.selectedMapItems = []
      this.page = 1
      this.perPage = 15;
      this.mapPage = 1
      this.mapPerPage = 15;
      this.currentDisabledCount = 0
      this.pagination = {current_page: 1, total_count: 0}
      this.mapPagination= {current_page: 1, total_count: 0}
    },

  }
}
</script>
